<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActive"
  >
    <div id="loading-show-d-sidebar" class="vs-con-loading__container">
      <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{compliance.client_name}} / {{compliance.facility}}</h4>
        <feather-icon icon="XIcon" @click.stop="close" class="cursor-pointer"></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="p-6">
          <h5>{{compliance.title}} / <span>{{compliance.vendor}}</span></h5>

          <!-- <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <input-date
              v-model="due_date" 
              :value="due_date"
              :label="$t('due_date')" 
              name="due_date"
              :disabled="!allowEditing"
              />
              
            </div>
          </div> -->

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{ $t('due_date') }}</label>
              <vs-input-number
                min="1"
                v-model="due_date"
                name="due_date"
                class="w-full"
                v-validate="'required'"
                max="31"
                maxlength="3"
                :disabled="!allowEditing"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('notifyDays')"
              >{{ errors.first('notifyDays') }}</span>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('sq_ft')}}</label>
              <vs-input-number
                min="1"
                v-model="sq_ft"
                name="sq_ft"
                class="w-full"
                :disabled="!allowEditing"
              />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col sm:w-1/2 w-full">
              <label>{{$t('maintenance')}}</label>
              <vs-input-number
                min="1"
                v-model="maintenance"
                name="maintenance"
                class="w-full"
                :disabled="!allowEditing"
              />
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <label>{{$t('property_tax')}}</label>
              <vs-input-number
                min="1"
                v-model="property_tax"
                name="property_tax"
                class="w-full"
                :disabled="!allowEditing"
              />
            </div>
          </div>

          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('extension_date')}}</label>
              <vs-input label v-model="compliance.extension_date" name="facility" class="w-full" disabled />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('lease_rate')}}</label>
              <vs-input label v-model="compliance.lease_rate" name="category" class="w-full" disabled />
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('escalation_period')}}</label>
              <vs-input
                label
                v-model="compliance.escalation_period"
                name="vendor"
                class="w-full"
                disabled
              />
            </div>
          </div>
          
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <label>{{$t('options')}}</label>
              <vs-input
                label
                v-model="compliance.options"
                name="expiration_date"
                class="w-full"
                disabled
              />
            </div>
        </div>
          
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button
          class="mr-6"
          @click.stop.prevent="submit()"
          :disabled="!validForm"
          v-if="allowEditing"
        >{{$t('submit')}}</vs-button>
        <vs-button type="border" color="danger" @click.stop="close">{{$t('cancel')}}</vs-button>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import compliance from '@/http/requests/compliance'
import InputDate from '@/components/custom/InputDate.vue'

export default {
  props:['compliance'],
  data() {
    return {
      due_date:0,
      sq_ft:0,  
      maintenance:0,
      property_tax:0,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      allowEditing:false
    }
  },
  computed: {
    isSidebarActive() {
      return this.$store.state.sidebar === 'showCompliance'
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  watch: {
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      this.allowEditing = this.hasPermission(['IU COMPLIANCE EDIT'])
      this.sq_ft = this.compliance.sq_ft
      this.maintenance = this.compliance.maintenance
      this.property_tax = this.compliance.property_tax
      this.due_date = Number(this.compliance.due_date)
    },
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    openLoading() {
      this.$vs.loading({
        container: '#loading-show-d-sidebar',
        scale: 0.6
      })
    },
    closeLoading() {
      this.$vs.loading.close(
        '#loading-show-d-sidebar > .con-vs-loading'
      )
    },
    validForm() {
      return this.file !== ''
    },
    submit() {
    this.openLoading()
      let form = new FormData()
      form.append('lease_id',this.compliance.lease_id)
      form.append('sq_ft',this.sq_ft)
      form.append('maintenance',this.maintenance)
      form.append('property_tax',this.property_tax)
      form.append('due_date',this.due_date)
      
      this.$store.dispatch('compliance/updateComplianceLease', form)
      .then(res => {
          this.$store.dispatch('getNotifications')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added'
          })
          this.closeLoading()
          this.close()
        })
        .catch(err => {
          this.closeLoading()
          if (422 === err.response.status) {
            let errors = err.response.data.errors
            let errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach(element => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0]
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR'
            })
          }
        })
    },
  },
  components: {
    VuePerfectScrollbar,
    InputDate
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
